import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    login_status: false,
    isFlag:false,
    currentNav: {},
    windowWidth: 0,
    isMobile: null, //是否是手机端访问
    showDropDownMenu: '', // 手机端显示哪个下拉菜单
    // defaultActive: '',
  },
  mutations: {
    setUserInfo(state, val) {
      state.userInfo = val
    },
    setLoginStatus(state, payload) {
      state.login_status = payload
    },
    setIsFlag(state,payload){
      state.isFlag = payload
    },
    setcurrentNav(state, payload) {
      state.currentNav = payload
    },
    setWindowWidth(state, payload) {
      state.windowWidth = payload
    },
    setWindowHeight(state, payload) {
      state.windowHeight = payload
    },
    setIsMobile(state,payload){
      state.isMobile = payload
    },
    setShowDropDownMenu(state,payload){
      state.showDropDownMenu = payload
    },
  },
  actions: {},
  getters: {
    userInfo: state => state.userInfo
  },
})